// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ==========================================
   Player Auto-evaluation Page
   ========================================== */

.ae-container {
  max-width: 720px;
  margin: 0 auto;
  padding: 0 16px 120px;
}

/* ---------- Loading & Empty States ---------- */

.ae-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 50vh;
  gap: 16px;
  color: var(--text-secondary, #64748b);
}

.ae-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 50vh;
  padding: 32px;
  text-align: center;
}

.ae-empty__icon {
  font-size: 64px;
  margin-bottom: 16px;
}

.ae-empty h3 {
  font-size: 22px;
  font-weight: 700;
  color: var(--text-color, #1e293b);
  margin: 0 0 8px;
}

.ae-empty p {
  font-size: 15px;
  color: var(--text-secondary, #64748b);
  margin: 0 0 24px;
  max-width: 320px;
  line-height: 1.5;
}

.ae-empty--welcome p {
  max-width: 480px;
}

/* ---------- Hero Banner ---------- */

.ae-hero {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: linear-gradient(135deg, #0877BC 0%, #065a92 100%);
  border-radius: 16px;
  padding: 24px;
  margin: 16px 0 24px;
  color: #fff;
  box-shadow: 0 8px 24px rgba(8, 119, 188, 0.25);
}

.ae-hero__title {
  font-size: 20px;
  font-weight: 700;
  margin: 0 0 6px;
  line-height: 1.3;
}

.ae-hero__subtitle {
  font-size: 14px;
  margin: 0;
  opacity: 0.85;
}

.ae-hero__progress {
  flex-shrink: 0;
  margin-left: 16px;
}

.ae-hero__progress-ring {
  position: relative;
  width: 72px;
  height: 72px;
}

.ae-hero__progress-ring svg {
  width: 100%;
  height: 100%;
  transform: rotate(-90deg);
}

.ae-progress-bg {
  fill: none;
  stroke: rgba(255, 255, 255, 0.2);
  stroke-width: 6;
}

.ae-progress-fill {
  fill: none;
  stroke: #fbbf24;
  stroke-width: 6;
  stroke-linecap: round;
  transition: stroke-dashoffset 0.6s cubic-bezier(0.4, 0, 0.2, 1);
}

.ae-hero__progress-text {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  font-weight: 700;
  color: #fff;
}

/* ---------- Session Card ---------- */

.ae-sessions {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.ae-session {
  background: var(--surface-color, #fff);
  border-radius: 14px;
  box-shadow: 0 4px 20px var(--shadow-color, rgba(0, 0, 0, 0.06));
  border: 1px solid var(--border-color, transparent);
  overflow: hidden;
}

.ae-session__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  background: var(--bg-color, #f8fafc);
  border-bottom: 1px solid var(--border-color, #e2e8f0);
}

.ae-session__info {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.ae-session__date {
  font-size: 15px;
  font-weight: 600;
  color: var(--text-color, #1e293b);
}

.ae-session__group {
  font-size: 12px;
  font-weight: 500;
  color: var(--brand-primary, #0877BC);
  background: rgba(8, 119, 188, 0.12);
  padding: 2px 10px;
  border-radius: 12px;
  width: fit-content;
}

.ae-session__meta {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 4px;
}

.ae-session__badge {
  font-size: 12px;
  font-weight: 600;
  color: #10b981;
  background: rgba(16, 185, 129, 0.12);
  padding: 3px 10px;
  border-radius: 12px;
}

.ae-session__duration {
  font-size: 12px;
  color: var(--text-secondary, #94a3b8);
}

.ae-session__exercises {
  padding: 12px 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

/* ---------- Exercise Evaluation Card ---------- */

.ae-exercise-card {
  border: 1.5px solid var(--border-color, #e2e8f0);
  border-radius: 12px;
  padding: 16px;
  background: var(--surface-color, #fff);
  transition: all 0.3s ease;
}

.ae-exercise-card:hover {
  border-color: var(--text-secondary, #cbd5e1);
  box-shadow: 0 4px 12px var(--shadow-color, rgba(0, 0, 0, 0.04));
}

.ae-exercise-card--complete {
  border-color: rgba(34, 197, 94, 0.4);
  background: rgba(34, 197, 94, 0.08);
}

.ae-exercise-card--priority {
  border-color: rgba(8, 119, 188, 0.45);
}

.ae-exercise-card__badges {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  align-items: center;
}

.ae-exercise-card__focus {
  display: inline-block;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.02em;
  padding: 2px 8px;
  border-radius: 10px;
}

.ae-exercise-card__focus--priority {
  color: #0877BC;
  background: rgba(8, 119, 188, 0.14);
}

.ae-exercise-card__focus--optional {
  color: #64748b;
  background: rgba(100, 116, 139, 0.12);
}

.ae-exercise-card__header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  margin-bottom: 12px;
  gap: 8px;
}

.ae-exercise-card__info {
  flex: 1 1;
  min-width: 0;
}

.ae-exercise-card__name {
  font-size: 15px;
  font-weight: 600;
  color: var(--text-color, #1e293b);
  margin: 0 0 6px;
  line-height: 1.3;
}

.ae-exercise-card__cb-badge {
  display: inline-block;
  font-size: 11px;
  font-weight: 600;
  color: var(--brand-primary, #0877BC);
  background: rgba(8, 119, 188, 0.12);
  padding: 2px 10px;
  border-radius: 10px;
}

.ae-exercise-card__duration {
  font-size: 12px;
  color: var(--text-secondary, #94a3b8);
  white-space: nowrap;
  font-weight: 500;
  flex-shrink: 0;
}

.ae-exercise-card__check {
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #22c55e;
  color: #fff;
  border-radius: 50%;
  font-size: 14px;
  font-weight: 700;
  flex-shrink: 0;
}

.ae-exercise-card__objective {
  font-size: 13px;
  color: var(--text-secondary, #64748b);
  margin: 0 0 14px;
  line-height: 1.5;
}

.ae-exercise-card__rating-section {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.ae-exercise-card__rating-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.ae-exercise-card__rating-label {
  font-size: 13px;
  font-weight: 600;
  color: var(--text-color, #475569);
  display: flex;
  align-items: center;
  gap: 6px;
}

.ae-rating-label-icon {
  font-size: 16px;
}

/* ---------- Rating Buttons ---------- */

.ae-rating-row {
  display: flex;
  gap: 6px;
}

.ae-rating-btn {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
  padding: 8px 4px;
  border: 2px solid var(--border-color, #e2e8f0);
  border-radius: 10px;
  background: var(--surface-color, #fff);
  cursor: pointer;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  min-width: 0;
}

.ae-rating-btn:hover {
  transform: translateY(-2px);
  border-color: var(--text-secondary, #cbd5e1);
  box-shadow: 0 4px 12px var(--shadow-color, rgba(0, 0, 0, 0.1));
}

.ae-rating-btn:active {
  transform: translateY(0);
}

.ae-rating-btn--active {
  transform: translateY(-2px);
  box-shadow: 0 4px 16px var(--shadow-color, rgba(0, 0, 0, 0.15));
}

.ae-rating-btn--active .ae-rating-btn__label {
  color: #fff;
}

.ae-rating-btn--active .ae-rating-btn__num {
  color: rgba(255, 255, 255, 0.9);
}

.ae-rating-btn__icon {
  font-size: 22px;
  line-height: 1;
}

.ae-rating-btn__num {
  font-size: 14px;
  font-weight: 700;
  color: var(--text-color, #475569);
  line-height: 1;
}

.ae-rating-btn__label {
  font-size: 9px;
  font-weight: 500;
  color: var(--text-secondary, #94a3b8);
  text-align: center;
  line-height: 1.2;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
}

/* ---------- Buttons ---------- */

.ae-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  font-size: 14px;
  font-weight: 600;
  border: none;
  border-radius: 10px;
  cursor: pointer;
  transition: all 0.2s;
  padding: 12px 24px;
}

.ae-btn--primary {
  background: linear-gradient(135deg, #0877BC 0%, #065a92 100%);
  color: #fff;
  box-shadow: 0 4px 12px rgba(8, 119, 188, 0.3);
}

.ae-btn--primary:hover:not(:disabled) {
  box-shadow: 0 6px 20px rgba(8, 119, 188, 0.4);
  transform: translateY(-1px);
}

.ae-btn--primary:active {
  transform: translateY(0);
}

.ae-btn--session {
  width: calc(100% - 32px);
  margin: 4px 16px 16px;
  background: linear-gradient(135deg, #059669 0%, #047857 100%);
  color: #fff;
  box-shadow: 0 4px 12px rgba(5, 150, 105, 0.25);
}

.ae-btn--session:hover:not(:disabled) {
  box-shadow: 0 6px 20px rgba(5, 150, 105, 0.35);
  transform: translateY(-1px);
}

.ae-btn--disabled {
  opacity: 0.45;
  cursor: not-allowed;
  box-shadow: none;
}

.ae-btn--disabled:hover {
  transform: none !important;
  box-shadow: none !important;
}

.ae-btn--large {
  width: 100%;
  padding: 16px;
  font-size: 16px;
  border-radius: 12px;
}

.ae-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

/* ---------- Sticky Footer ---------- */

.ae-footer {
  position: fixed;
  bottom: 70px;
  left: 0;
  right: 0;
  padding: 12px 16px;
  background: var(--glass-bg, rgba(255, 255, 255, 0.95));
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  border-top: 1px solid var(--border-color, #e2e8f0);
  z-index: 100;
  max-width: 720px;
  margin: 0 auto;
}

/* ---------- Responsive ---------- */

@media (max-width: 480px) {
  .ae-hero {
    padding: 18px;
    flex-direction: column;
    text-align: center;
    gap: 16px;
  }

  .ae-hero__progress {
    margin-left: 0;
  }

  .ae-hero__title {
    font-size: 18px;
  }

  .ae-rating-btn {
    padding: 6px 2px;
  }

  .ae-rating-btn__icon {
    font-size: 18px;
  }

  .ae-rating-btn__num {
    font-size: 12px;
  }

  .ae-rating-btn__label {
    font-size: 8px;
  }

  .ae-exercise-card {
    padding: 12px;
  }

  .ae-exercise-card__name {
    font-size: 14px;
  }

  .ae-session__header {
    flex-direction: column;
    gap: 8px;
    align-items: flex-start;
  }

  .ae-session__meta {
    flex-direction: row;
    align-items: center;
  }
}

/* ---------- Animation ---------- */

@keyframes ae-fadeIn {
  from {
    opacity: 0;
    transform: translateY(12px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.ae-session {
  animation: ae-fadeIn 0.4s ease-out;
}

.ae-session:nth-child(2) { animation-delay: 0.1s; }
.ae-session:nth-child(3) { animation-delay: 0.2s; }
.ae-session:nth-child(4) { animation-delay: 0.3s; }
.ae-session:nth-child(5) { animation-delay: 0.4s; }

.ae-exercise-card {
  animation: ae-fadeIn 0.3s ease-out;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Player/PlayerAutoevaluation.css"],"names":[],"mappings":"AAAA;;+CAE+C;;AAE/C;EACE,gBAAgB;EAChB,cAAc;EACd,qBAAqB;AACvB;;AAEA,iDAAiD;;AAEjD;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,SAAS;EACT,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iCAAiC;EACjC,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,qCAAqC;EACrC,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,sCAAsC;;AAEtC;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,6DAA6D;EAC7D,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,8CAA8C;AAChD;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,SAAS;EACT,aAAa;AACf;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,eAAe;EACf,eAAe;EACf,qBAAqB;EACrB,+DAA+D;AACjE;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA,uCAAuC;;AAEvC;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,sCAAsC;EACtC,mBAAmB;EACnB,+DAA+D;EAC/D,kDAAkD;EAClD,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,oCAAoC;EACpC,qDAAqD;AACvD;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,oCAAoC;EACpC,mCAAmC;EACnC,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,oCAAoC;EACpC,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,qCAAqC;AACvC;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,mDAAmD;;AAEnD;EACE,gDAAgD;EAChD,mBAAmB;EACnB,aAAa;EACb,sCAAsC;EACtC,yBAAyB;AAC3B;;AAEA;EACE,4CAA4C;EAC5C,+DAA+D;AACjE;;AAEA;EACE,oCAAoC;EACpC,mCAAmC;AACrC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mCAAmC;AACrC;;AAEA;EACE,cAAc;EACd,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iCAAiC;EACjC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,oCAAoC;EACpC,mCAAmC;EACnC,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,qCAAqC;EACrC,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,qCAAqC;EACrC,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iCAAiC;EACjC,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;AACjB;;AAEA,yCAAyC;;AAEzC;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,8CAA8C;EAC9C,mBAAmB;EACnB,sCAAsC;EACtC,eAAe;EACf,iDAAiD;EACjD,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,4CAA4C;EAC5C,8DAA8D;AAChE;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,2BAA2B;EAC3B,+DAA+D;AACjE;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iCAAiC;EACjC,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,qCAAqC;EACrC,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;AACjB;;AAEA,kCAAkC;;AAElC;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,6DAA6D;EAC7D,WAAW;EACX,6CAA6C;AAC/C;;AAEA;EACE,6CAA6C;EAC7C,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;EACxB,qBAAqB;EACrB,6DAA6D;EAC7D,WAAW;EACX,8CAA8C;AAChD;;AAEA;EACE,8CAA8C;EAC9C,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,aAAa;EACb,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,wCAAwC;;AAExC;EACE,eAAe;EACf,YAAY;EACZ,OAAO;EACP,QAAQ;EACR,kBAAkB;EAClB,sDAAsD;EACtD,2BAA2B;EAC3B,mCAAmC;EACnC,kDAAkD;EAClD,YAAY;EACZ,gBAAgB;EAChB,cAAc;AAChB;;AAEA,qCAAqC;;AAErC;EACE;IACE,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,SAAS;EACX;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,QAAQ;IACR,uBAAuB;EACzB;;EAEA;IACE,mBAAmB;IACnB,mBAAmB;EACrB;AACF;;AAEA,oCAAoC;;AAEpC;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,kCAAkC;AACpC;;AAEA,2BAA2B,qBAAqB,EAAE;AAClD,2BAA2B,qBAAqB,EAAE;AAClD,2BAA2B,qBAAqB,EAAE;AAClD,2BAA2B,qBAAqB,EAAE;;AAElD;EACE,kCAAkC;AACpC","sourcesContent":["/* ==========================================\n   Player Auto-evaluation Page\n   ========================================== */\n\n.ae-container {\n  max-width: 720px;\n  margin: 0 auto;\n  padding: 0 16px 120px;\n}\n\n/* ---------- Loading & Empty States ---------- */\n\n.ae-loading {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  min-height: 50vh;\n  gap: 16px;\n  color: var(--text-secondary, #64748b);\n}\n\n.ae-empty {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  min-height: 50vh;\n  padding: 32px;\n  text-align: center;\n}\n\n.ae-empty__icon {\n  font-size: 64px;\n  margin-bottom: 16px;\n}\n\n.ae-empty h3 {\n  font-size: 22px;\n  font-weight: 700;\n  color: var(--text-color, #1e293b);\n  margin: 0 0 8px;\n}\n\n.ae-empty p {\n  font-size: 15px;\n  color: var(--text-secondary, #64748b);\n  margin: 0 0 24px;\n  max-width: 320px;\n  line-height: 1.5;\n}\n\n.ae-empty--welcome p {\n  max-width: 480px;\n}\n\n/* ---------- Hero Banner ---------- */\n\n.ae-hero {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  background: linear-gradient(135deg, #0877BC 0%, #065a92 100%);\n  border-radius: 16px;\n  padding: 24px;\n  margin: 16px 0 24px;\n  color: #fff;\n  box-shadow: 0 8px 24px rgba(8, 119, 188, 0.25);\n}\n\n.ae-hero__title {\n  font-size: 20px;\n  font-weight: 700;\n  margin: 0 0 6px;\n  line-height: 1.3;\n}\n\n.ae-hero__subtitle {\n  font-size: 14px;\n  margin: 0;\n  opacity: 0.85;\n}\n\n.ae-hero__progress {\n  flex-shrink: 0;\n  margin-left: 16px;\n}\n\n.ae-hero__progress-ring {\n  position: relative;\n  width: 72px;\n  height: 72px;\n}\n\n.ae-hero__progress-ring svg {\n  width: 100%;\n  height: 100%;\n  transform: rotate(-90deg);\n}\n\n.ae-progress-bg {\n  fill: none;\n  stroke: rgba(255, 255, 255, 0.2);\n  stroke-width: 6;\n}\n\n.ae-progress-fill {\n  fill: none;\n  stroke: #fbbf24;\n  stroke-width: 6;\n  stroke-linecap: round;\n  transition: stroke-dashoffset 0.6s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.ae-hero__progress-text {\n  position: absolute;\n  inset: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 16px;\n  font-weight: 700;\n  color: #fff;\n}\n\n/* ---------- Session Card ---------- */\n\n.ae-sessions {\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n}\n\n.ae-session {\n  background: var(--surface-color, #fff);\n  border-radius: 14px;\n  box-shadow: 0 4px 20px var(--shadow-color, rgba(0, 0, 0, 0.06));\n  border: 1px solid var(--border-color, transparent);\n  overflow: hidden;\n}\n\n.ae-session__header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 16px 20px;\n  background: var(--bg-color, #f8fafc);\n  border-bottom: 1px solid var(--border-color, #e2e8f0);\n}\n\n.ae-session__info {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.ae-session__date {\n  font-size: 15px;\n  font-weight: 600;\n  color: var(--text-color, #1e293b);\n}\n\n.ae-session__group {\n  font-size: 12px;\n  font-weight: 500;\n  color: var(--brand-primary, #0877BC);\n  background: rgba(8, 119, 188, 0.12);\n  padding: 2px 10px;\n  border-radius: 12px;\n  width: fit-content;\n}\n\n.ae-session__meta {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  gap: 4px;\n}\n\n.ae-session__badge {\n  font-size: 12px;\n  font-weight: 600;\n  color: #10b981;\n  background: rgba(16, 185, 129, 0.12);\n  padding: 3px 10px;\n  border-radius: 12px;\n}\n\n.ae-session__duration {\n  font-size: 12px;\n  color: var(--text-secondary, #94a3b8);\n}\n\n.ae-session__exercises {\n  padding: 12px 16px;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n/* ---------- Exercise Evaluation Card ---------- */\n\n.ae-exercise-card {\n  border: 1.5px solid var(--border-color, #e2e8f0);\n  border-radius: 12px;\n  padding: 16px;\n  background: var(--surface-color, #fff);\n  transition: all 0.3s ease;\n}\n\n.ae-exercise-card:hover {\n  border-color: var(--text-secondary, #cbd5e1);\n  box-shadow: 0 4px 12px var(--shadow-color, rgba(0, 0, 0, 0.04));\n}\n\n.ae-exercise-card--complete {\n  border-color: rgba(34, 197, 94, 0.4);\n  background: rgba(34, 197, 94, 0.08);\n}\n\n.ae-exercise-card--priority {\n  border-color: rgba(8, 119, 188, 0.45);\n}\n\n.ae-exercise-card__badges {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n  align-items: center;\n}\n\n.ae-exercise-card__focus {\n  display: inline-block;\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.02em;\n  padding: 2px 8px;\n  border-radius: 10px;\n}\n\n.ae-exercise-card__focus--priority {\n  color: #0877BC;\n  background: rgba(8, 119, 188, 0.14);\n}\n\n.ae-exercise-card__focus--optional {\n  color: #64748b;\n  background: rgba(100, 116, 139, 0.12);\n}\n\n.ae-exercise-card__header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  margin-bottom: 12px;\n  gap: 8px;\n}\n\n.ae-exercise-card__info {\n  flex: 1;\n  min-width: 0;\n}\n\n.ae-exercise-card__name {\n  font-size: 15px;\n  font-weight: 600;\n  color: var(--text-color, #1e293b);\n  margin: 0 0 6px;\n  line-height: 1.3;\n}\n\n.ae-exercise-card__cb-badge {\n  display: inline-block;\n  font-size: 11px;\n  font-weight: 600;\n  color: var(--brand-primary, #0877BC);\n  background: rgba(8, 119, 188, 0.12);\n  padding: 2px 10px;\n  border-radius: 10px;\n}\n\n.ae-exercise-card__duration {\n  font-size: 12px;\n  color: var(--text-secondary, #94a3b8);\n  white-space: nowrap;\n  font-weight: 500;\n  flex-shrink: 0;\n}\n\n.ae-exercise-card__check {\n  width: 24px;\n  height: 24px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: #22c55e;\n  color: #fff;\n  border-radius: 50%;\n  font-size: 14px;\n  font-weight: 700;\n  flex-shrink: 0;\n}\n\n.ae-exercise-card__objective {\n  font-size: 13px;\n  color: var(--text-secondary, #64748b);\n  margin: 0 0 14px;\n  line-height: 1.5;\n}\n\n.ae-exercise-card__rating-section {\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n}\n\n.ae-exercise-card__rating-group {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.ae-exercise-card__rating-label {\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--text-color, #475569);\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.ae-rating-label-icon {\n  font-size: 16px;\n}\n\n/* ---------- Rating Buttons ---------- */\n\n.ae-rating-row {\n  display: flex;\n  gap: 6px;\n}\n\n.ae-rating-btn {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 2px;\n  padding: 8px 4px;\n  border: 2px solid var(--border-color, #e2e8f0);\n  border-radius: 10px;\n  background: var(--surface-color, #fff);\n  cursor: pointer;\n  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);\n  min-width: 0;\n}\n\n.ae-rating-btn:hover {\n  transform: translateY(-2px);\n  border-color: var(--text-secondary, #cbd5e1);\n  box-shadow: 0 4px 12px var(--shadow-color, rgba(0, 0, 0, 0.1));\n}\n\n.ae-rating-btn:active {\n  transform: translateY(0);\n}\n\n.ae-rating-btn--active {\n  transform: translateY(-2px);\n  box-shadow: 0 4px 16px var(--shadow-color, rgba(0, 0, 0, 0.15));\n}\n\n.ae-rating-btn--active .ae-rating-btn__label {\n  color: #fff;\n}\n\n.ae-rating-btn--active .ae-rating-btn__num {\n  color: rgba(255, 255, 255, 0.9);\n}\n\n.ae-rating-btn__icon {\n  font-size: 22px;\n  line-height: 1;\n}\n\n.ae-rating-btn__num {\n  font-size: 14px;\n  font-weight: 700;\n  color: var(--text-color, #475569);\n  line-height: 1;\n}\n\n.ae-rating-btn__label {\n  font-size: 9px;\n  font-weight: 500;\n  color: var(--text-secondary, #94a3b8);\n  text-align: center;\n  line-height: 1.2;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  max-width: 100%;\n}\n\n/* ---------- Buttons ---------- */\n\n.ae-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  font-size: 14px;\n  font-weight: 600;\n  border: none;\n  border-radius: 10px;\n  cursor: pointer;\n  transition: all 0.2s;\n  padding: 12px 24px;\n}\n\n.ae-btn--primary {\n  background: linear-gradient(135deg, #0877BC 0%, #065a92 100%);\n  color: #fff;\n  box-shadow: 0 4px 12px rgba(8, 119, 188, 0.3);\n}\n\n.ae-btn--primary:hover:not(:disabled) {\n  box-shadow: 0 6px 20px rgba(8, 119, 188, 0.4);\n  transform: translateY(-1px);\n}\n\n.ae-btn--primary:active {\n  transform: translateY(0);\n}\n\n.ae-btn--session {\n  width: calc(100% - 32px);\n  margin: 4px 16px 16px;\n  background: linear-gradient(135deg, #059669 0%, #047857 100%);\n  color: #fff;\n  box-shadow: 0 4px 12px rgba(5, 150, 105, 0.25);\n}\n\n.ae-btn--session:hover:not(:disabled) {\n  box-shadow: 0 6px 20px rgba(5, 150, 105, 0.35);\n  transform: translateY(-1px);\n}\n\n.ae-btn--disabled {\n  opacity: 0.45;\n  cursor: not-allowed;\n  box-shadow: none;\n}\n\n.ae-btn--disabled:hover {\n  transform: none !important;\n  box-shadow: none !important;\n}\n\n.ae-btn--large {\n  width: 100%;\n  padding: 16px;\n  font-size: 16px;\n  border-radius: 12px;\n}\n\n.ae-btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n/* ---------- Sticky Footer ---------- */\n\n.ae-footer {\n  position: fixed;\n  bottom: 70px;\n  left: 0;\n  right: 0;\n  padding: 12px 16px;\n  background: var(--glass-bg, rgba(255, 255, 255, 0.95));\n  backdrop-filter: blur(20px);\n  -webkit-backdrop-filter: blur(20px);\n  border-top: 1px solid var(--border-color, #e2e8f0);\n  z-index: 100;\n  max-width: 720px;\n  margin: 0 auto;\n}\n\n/* ---------- Responsive ---------- */\n\n@media (max-width: 480px) {\n  .ae-hero {\n    padding: 18px;\n    flex-direction: column;\n    text-align: center;\n    gap: 16px;\n  }\n\n  .ae-hero__progress {\n    margin-left: 0;\n  }\n\n  .ae-hero__title {\n    font-size: 18px;\n  }\n\n  .ae-rating-btn {\n    padding: 6px 2px;\n  }\n\n  .ae-rating-btn__icon {\n    font-size: 18px;\n  }\n\n  .ae-rating-btn__num {\n    font-size: 12px;\n  }\n\n  .ae-rating-btn__label {\n    font-size: 8px;\n  }\n\n  .ae-exercise-card {\n    padding: 12px;\n  }\n\n  .ae-exercise-card__name {\n    font-size: 14px;\n  }\n\n  .ae-session__header {\n    flex-direction: column;\n    gap: 8px;\n    align-items: flex-start;\n  }\n\n  .ae-session__meta {\n    flex-direction: row;\n    align-items: center;\n  }\n}\n\n/* ---------- Animation ---------- */\n\n@keyframes ae-fadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(12px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.ae-session {\n  animation: ae-fadeIn 0.4s ease-out;\n}\n\n.ae-session:nth-child(2) { animation-delay: 0.1s; }\n.ae-session:nth-child(3) { animation-delay: 0.2s; }\n.ae-session:nth-child(4) { animation-delay: 0.3s; }\n.ae-session:nth-child(5) { animation-delay: 0.4s; }\n\n.ae-exercise-card {\n  animation: ae-fadeIn 0.3s ease-out;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
